import { makeStyles } from "@material-ui/core";
import clsx from "clsx";
import React, { useEffect, useState } from "react";
import { CircularProgressbarWithChildren } from "react-circular-progressbar";
import { useDispatch } from "react-redux";
import { toAbsoluteUrl } from "../../../../../../Utils/_helpers";
import { setSelectedSounds } from "../../../state/slices/soundsSlice";
import SoundsCard from "./SoundsCard";

const useStyles = makeStyles((theme) => ({
  playIcon: {
    paddingLeft: "5px",
    paddingTop: "2px",
  },
  pauseIcon: {
    paddingTop: "5px",
    paddingLeft: "8px",
  },
}));

const SoundTabContent = ({
  sounds,
  togglePlayAndPause,
  soundFileList,
  soundFilesPausedDuration,
  handleStopAudio,
}) => {
  const [soundCurrentTime, setSoundCurrentTime] = useState(0);
  const [progress, setProgress] = React.useState(0);
  const [playingSound, setPlayingSound] = React.useState(null);

  const dispatch = useDispatch();

  const classes = useStyles();

  const Player = ({ sound, togglePlayAndPause }) => {
    return (
      <img
        key={sound.id}
        alt="sound"
        className={` ${clsx({
          [classes.playIcon]: !sound.playing,
          [classes.pauseIcon]: sound.playing,
        })}`}
        style={{
          cursor: "pointer",
          width: 42,
          height: 42,
          objectFit: "none",
        }}
        onClick={togglePlayAndPause}
        src={
          sound.playing
            ? toAbsoluteUrl("/media/sr/icons/pause-sound.svg")
            : toAbsoluteUrl("/media/sr/icons/play-icon.svg")
        }
      />
    );
  };
  useEffect(() => {
    let soundFileFound = soundFileList.find((file) => file.playing);
    let pausedSound = soundFilesPausedDuration.find(
      (file) =>
        file.currentDuration > 0 &&
        soundFileFound &&
        soundFileFound.id === file.id
    );

    let pausedSoundTime = 0;
    if (pausedSound) {
      pausedSoundTime = pausedSound.currentDuration;
    }
    const timer = setInterval(
      () => {
        if (pausedSound) {
          pausedSoundTime = pausedSoundTime + 1;
          setPlayingSound(null);
          setSoundCurrentTime((prevTime) => parseInt(pausedSoundTime));
        } else if (soundFileFound) {
          setPlayingSound(soundFileFound.url);
          setSoundCurrentTime((prevTime) =>
            prevTime >= soundFileFound.duration ? 0 : prevTime + 1
          );
        }
      },
      soundFileFound ? 1000 : null
    );
    if (soundFilesPausedDuration.length === 0) {
      setProgress(0);
      setSoundCurrentTime(0);
    }
    return () => {
      setPlayingSound(null);
      clearInterval(timer);
    };
  }, [soundFileList, JSON.stringify(soundFilesPausedDuration)]);

  useEffect(() => {
    let findSound = soundFileList.find((sound) => sound.playing === true);
    if (findSound) {
      setProgress(Math.ceil((soundCurrentTime / findSound.duration) * 100));
    }
  }, [soundCurrentTime]);

  const handleCheckedSounds = (selectedSounds) => {
    dispatch(setSelectedSounds(selectedSounds));
  };

  const displayAudioDuration = (soundFile) => {
    let durationInSecs = "0 sec";
    let secondsLabel = " secs";
    if (soundFile.duration) {
      durationInSecs = soundFile.duration.toFixed(0);
      if (durationInSecs < 10) {
        if (durationInSecs < 2) {
          secondsLabel = " sec";
        }
        durationInSecs = "0" + durationInSecs + secondsLabel;
      } else {
        durationInSecs = durationInSecs + secondsLabel;
      }
    }
    return durationInSecs;
  };

  const getSoundFileFormat = (serverName) => {
    if (serverName) {
      if (serverName.includes(".mp3")) return "MP3";
      return "WAV";
    }
    return "";
  };
  return (
    <div className="row mx-5 py-10">
      {sounds.length > 0 ? (
        sounds.map((sound, index) => {
          return (
            <SoundsCard
              key={sound.id}
              id={sound.id}
              sound={sound}
              soundFilesPausedDuration={soundFilesPausedDuration}
              handleCheckedSounds={handleCheckedSounds}
            >
              {soundFileList.map((soundFile) => (
                <>
                  {soundFile.url === sound?.soundlibobj?.soundfile &&
                    soundFile.id === sound?.id && (
                      <div
                        style={{ width: "53px" }}
                        sound={soundFile}
                        key={soundFile.url}
                      >
                        <div
                          className="d-block"
                          style={{ minHeight: 56, position: "relative" }}
                        >
                          <div
                            style={{
                              position: "relative",
                            }}
                          >
                            <CircularProgressbarWithChildren
                              key={sound?.soundlibobj?.soundfile}
                              value={
                                soundFile.playing ||
                                (soundFilesPausedDuration.length &&
                                  soundFilesPausedDuration[0].id === sound.id &&
                                  soundFilesPausedDuration[0].currentDuration >
                                    0)
                                  ? progress
                                  : 0
                              }
                              strokeWidth={11}
                              maxValue={100}
                              styles={{
                                path: {
                                  stroke: `#ff7800`,
                                  strokeLinecap: "round",
                                  transition: "stroke-dashoffset 0.5s ease 0s",
                                  transform: "rotate(0)",
                                },
                                trail: {
                                  stroke: "#fff",
                                  strokeLinecap: "round",
                                  transform: "rotate(0)",
                                },
                              }}
                            >
                              <div
                                style={{
                                  background: "#fff",
                                  borderRadius: "43px",
                                  width: "43px",
                                  height: "43px",
                                  display: "flex",
                                  justifyContent: "center",
                                  alignItems: "center",
                                  boxShadow: "0 0 4px 0 rgba(0, 0, 0, 0.11)",
                                }}
                              >
                                <Player
                                  key={index}
                                  sound={soundFile}
                                  togglePlayAndPause={togglePlayAndPause(
                                    index,
                                    sound
                                  )}
                                />
                              </div>
                            </CircularProgressbarWithChildren>
                          </div>

                          {(soundFile.playing ||
                            (!!soundFilesPausedDuration.length &&
                              soundFilesPausedDuration[0].id === sound.id &&
                              soundFilesPausedDuration[0].currentDuration >
                                0)) && (
                            <div
                              className="mt-2 ml-19"
                              style={{
                                cursor: "pointer",
                                background: "#fff",
                                borderRadius: "43px",
                                padding: 17,
                                boxShadow: "0 0 4px 0 rgba(0, 0, 0, 0.11)",
                                position: "absolute",
                                left: 10,
                                top: -7,
                              }}
                              onClick={() => handleStopAudio(sound.id)}
                            >
                              <img
                                key={sound.id}
                                alt="sound"
                                style={{
                                  objectFit: "contain",
                                  width: "20px",
                                  height: "16px",
                                }}
                                src={"/media/sr/icons/stop-sound.svg"}
                              />
                            </div>
                          )}
                        </div>
                        <div
                          className="d-flex ml-n3 mt-2"
                          style={{
                            color: "#ff7800",
                            minWidth: "200px",
                            whiteSpace: "pre",
                          }}
                        >
                          <span className="mr-1">
                            {`${getSoundFileFormat(
                              sound?.soundlibobj?.servername
                            )},`}
                          </span>
                          <span>{`${displayAudioDuration(soundFile)}`}</span>
                        </div>
                      </div>
                    )}
                </>
              ))}
            </SoundsCard>
          );
        })
      ) : (
        <>
          {sounds.length === 0 && (
            <>
              <div
                className="d-flex justify-content-center align-items-center w-100"
                style={{
                  height: "300px",
                  fontSize: "18px",
                  fontWeight: "500",
                }}
              >
                No data available
              </div>
            </>
          )}
        </>
      )}
    </div>
  );
};

export default SoundTabContent;
